import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HashRouter } from "react-router-dom";
import './i18n';

// ReactDOM.render(
//   <React.StrictMode>
//     {/*<HashRouter>*/}
//       <App />
//     {/*</HashRouter>*/}
//   </React.StrictMode>,
//   document.getElementById('root')
// );

const rootElement = document.getElementById("root");

if (rootElement?.hasChildNodes()) {
  console.log("hydrate")
  ReactDOM.hydrate(<React.StrictMode>
    {/* <HashRouter> */}
      <App />
    {/* </HashRouter> */}
  </React.StrictMode>, rootElement);
} else {
  console.log("render")
  ReactDOM.render(<React.StrictMode>
    {/* <HashRouter> */}
      <App />
    {/* </HashRouter> */}
  </React.StrictMode>, rootElement);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
